import JavaScriptObfuscator from "javascript-obfuscator";

import getEnv from "@utils/getEnv";

const getSecondLocale = (locale: string): string => {
  const map = {
    en: "US",
    lv: "LV",
    ee: "EE",
    lt: "LT",
    ru: "RU",
  };

  return map[locale];
};

const scriptLoadPromise = async (node: HTMLElement, defaultLocale: string, locale: string): Promise<void> => {
  if (typeof window === "undefined") {
    return;
  }

  const htmlNode = node;

  const script = document.createElement("script");
  const apiKey = getEnv("CHAT_BOT_API_KEY");
  const scriptContent = document.createTextNode(
    JavaScriptObfuscator.obfuscate(
      `
      window['BOT_WEB_INTERFACE_BASE_URL'] = 'https://chatbot.alturing.eu/bu/JavaHookServer/static/';
      window['BOT_WEB_INTERFACE_SETTINGS'] = {
          botName: ${getEnv(`CHAT_BOT_ID_${defaultLocale?.toUpperCase()}`)},
          botEnvironment: "${getEnv("APP_ENV") === "prod" ? "prod" : "test"}",
          botLocale: "${locale}_${getSecondLocale(locale)}.UTF-8",
          setEntitiesOnAllMessages: {url: window.location.href, pagetitle: document.title},
          alwaysUseSmallIcon: true,
          enableChatResize: true,
          hookEndpoint: 'https://chatbot.alturing.eu/bu/JavaHookServer/api/v1/',
          googleMaps: {
            apiKey: "${apiKey}"
          }
      };    
  `,
      {
        compact: false,
        controlFlowFlattening: true,
        controlFlowFlatteningThreshold: 1,
        numbersToExpressions: true,
        simplify: true,
        stringArrayShuffle: true,
        splitStrings: true,
        stringArrayThreshold: 1,
      }
    ).getObfuscatedCode()
  );

  script.appendChild(scriptContent);

  script.charset = "utf-8";
  document.head.appendChild(script);
  const botElement = document.createElement("app-root");
  botElement.classList.add("app-root");
  htmlNode.innerHTML = '<app-root class="app-root"></app-root>';
  const botScript = document.createElement("script");
  botScript.src = "https://chatbot.alturing.eu/bu/JavaHookServer/static/index.js";
  botScript.defer = true;
  document.body.appendChild(botScript);
};

const createBot = async (node: HTMLElement, defaultLocale: string, locale: string): Promise<void> => {
  await scriptLoadPromise(node, defaultLocale, locale);
};

export default createBot;
